/**
 * The file name a server put into `Content-Disposition`, or null when the
 * header is absent (CORS must expose it) or carries no name. Handles both the
 * plain `filename="..."` form and the RFC 5987 `filename*=UTF-8''...` form.
 */
export function filenameFromContentDisposition(
  header: string | null | undefined,
): string | null {
  if (!header) return null;
  const extended = /filename\*=(?:UTF-8|utf-8)''([^;]+)/.exec(header);
  if (extended) {
    try {
      return decodeURIComponent(extended[1].trim());
    } catch {
      /* fall through to the plain form */
    }
  }
  const plain = /filename="?([^";]+)"?/.exec(header);
  return plain ? plain[1].trim() || null : null;
}
